import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {ControlContainer, NgForm} from "@angular/forms";
import {ToastService} from "../../../../services/toast/toast.service";
import {ConteudoRim} from "../../../../core/conteudo-rim";
import {ArquivoMetadados} from "../../../../core/arquivo-metadado";
import {ArquivoConteudoRimService} from "../../../../services/arquivo-conteudo-rim/arquivo-conteudo-rim.service";
import {FileUtils} from "../../../../utils/file-utils";

@Component({
    selector: "conteudo-anexo-rim",
    templateUrl: "./conteudo-anexo-rim.component.html",
    styleUrls: ["./conteudo-anexo-rim.component.css"],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
})
export class ConteudoAnexoRimComponent implements OnInit {

    @Input() conteudo: ConteudoRim;
    @Input() index: number;
    @Input() camposDesabilitados: boolean;

    pinRandom = Math.random();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private arquivoConteudoRimService: ArquivoConteudoRimService,
                private fileUtils: FileUtils) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    fileChangeEvent(event: any): void {
        if (event.target.files[0].size > 1 * 1024 * 1024) {
            this.toastService.showAlerta("O arquivo deve ter no máximo 1MB!");
            return;
        }

        //accept=".pdf, .jpg, .jpeg, .png, .gif"
        if (event.target.files[0].type != "application/pdf"
            && event.target.files[0].type != "image/jpeg"
            && event.target.files[0].type != "image/png"
            && event.target.files[0].type != "image/gif") {
            this.toastService.showAlerta("O arquivo deve ser do tipo PDF, JPG, JPEG, PNG ou GIF!");
            return;
        }

        this.conteudo.anexo = event.target.files[0];
        this.conteudo.isAnexoAlterado = true;

        this.conteudo.metadados = new ArquivoMetadados();
        this.conteudo.metadados.nmArquivo = this.conteudo.anexo.name;
        this.conteudo.metadados.dsTipoArquivo = this.conteudo.anexo.type;

        this.toastService.showSucesso("Arquivo anexado com sucesso!");
    }

    baixarArquivo() {
        if (this.conteudo.id && !this.conteudo.isAnexoAlterado) {
            this.arquivoConteudoRimService.get(this.conteudo.id).subscribe(
                (res) => {
                    this.fileUtils.downloadFile(res, this.conteudo.metadados.nmArquivo, this.conteudo.metadados.dsTipoArquivo);
                },
                (err) => {
                    this.toastService.showAlerta("Erro ao baixar arquivo!");
                }
            );
        } else if (this.conteudo.isAnexoAlterado) {
            this.fileUtils.downloadFile(this.conteudo.anexo, this.conteudo.metadados.nmArquivo, this.conteudo.metadados.dsTipoArquivo);
        }
    }

}
